export default __webpack_public_path__ + "static/media/Hair_7_M_C1.8871a5a0.svg";